import React, { useEffect, useState } from "react";
import styled from "styled-components";
import GithubIcon from "../GithubIcon";
import LinkedInIcon from "../LinkedInIcon";
import { colors, font, layout } from "./theme";

const Bar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: ${layout.menuBarHeight}px;
  z-index: 100000;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background: rgba(253, 253, 251, 0.7);
  backdrop-filter: blur(10px);
  border-bottom: 2px solid ${colors.ink};
  font-family: ${font.body};
`;

const Brand = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: ${colors.ink};
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Menu = styled.nav`
  display: flex;
  gap: 14px;
  margin-left: 22px;

  span {
    font-size: 13px;
    color: ${colors.inkSoft};
    font-weight: 600;
  }

  @media (max-width: 680px) {
    display: none;
  }
`;

const Right = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 14px;
`;

const IconLink = styled.a`
  display: flex;
  align-items: center;
  width: 20px;
  height: 20px;
  opacity: 0.8;
  transition: opacity 0.12s ease, transform 0.12s ease;

  &:hover {
    opacity: 1;
    transform: translateY(-1px);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

const Clock = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.ink};
  font-variant-numeric: tabular-nums;
`;

const MenuBar = () => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000 * 15);
    return () => clearInterval(id);
  }, []);

  const time = now.toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
  });
  const day = now.toLocaleDateString([], {
    weekday: "short",
    month: "short",
    day: "numeric",
  });

  return (
    <Bar>
      <Brand>Harrison OS</Brand>
      <Menu>
        <span>File</span>
        <span>Edit</span>
        <span>View</span>
        <span>Help</span>
      </Menu>
      <Right>
        <IconLink
          href="https://github.com/harriq"
          target="_blank"
          rel="noreferrer"
          title="GitHub"
        >
          <GithubIcon color={colors.ink} />
        </IconLink>
        <IconLink
          href="https://www.linkedin.com/in/harrisonqu/"
          target="_blank"
          rel="noreferrer"
          title="LinkedIn"
        >
          <LinkedInIcon color={colors.ink} />
        </IconLink>
        <Clock>
          {day} &nbsp; {time}
        </Clock>
      </Right>
    </Bar>
  );
};

export default MenuBar;
